import { render, staticRenderFns } from "./nutrients.vue?vue&type=template&id=82a920ac&scoped=true&"
import script from "./nutrients.vue?vue&type=script&lang=js&"
export * from "./nutrients.vue?vue&type=script&lang=js&"
import style0 from "./nutrients.vue?vue&type=style&index=0&id=82a920ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a920ac",
  null
  
)

export default component.exports